import React, { useEffect, useState } from "react";
import { Box, Toolbar, Typography } from "@mui/material";
import TableRowsLoader from "../../../components/common/Loader/tableLoader";
import PartnershipsTable from "../../../components/partnershipsTable/PartnershipsTable";
import NewPartnershipDrawer from "../../../components/partnershipsTable/NewPartnershipDrawer";
import PartnershipDetails from "./PartnershipDetails";
import "./styles.scss";
import { PartnershipType } from "../../../types/genericType";
import { useDispatch, useSelector } from "react-redux";
import {
  setPartnerships,
  setSelectedPartnership,
} from "../../../redux/features/partnershipsSlice";
import { getAllPartnerships } from "../../../services/partnershipService";

const Partnerships = () => {
  const { partnershipsData, selectedPartnership } = useSelector(
    (state: any) => state.partnershipsState
  );
  const [showDetails, setShowDetails] = useState(false);
  const [openEditDrawer, setOpenEditDrawer] = useState(false);
  const dispatch = useDispatch();

  const setPartnershipsData = (partnershipsData: PartnershipType[]) => {
    dispatch(setPartnerships(partnershipsData));
  };

  const updateSelectedPartnership = (partnership: PartnershipType) => {
    dispatch(setSelectedPartnership(partnership));
  };

  const getPartnershipsData = () => {
    getAllPartnerships()
      .then((res) => {
        setPartnershipsData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getPartnershipsData();
  }, []);

  return showDetails && selectedPartnership ? (
    <>
      <PartnershipDetails
        selectedPartnership={selectedPartnership}
        setShowDetails={setShowDetails}
        setOpenEditDrawer={setOpenEditDrawer}
      />
      <NewPartnershipDrawer
        getPartnershipsData={getPartnershipsData}
        partnershipsData={partnershipsData}
        setPartnershipsData={setPartnershipsData}
        openEditDrawer={openEditDrawer}
        selectedPartnership={selectedPartnership}
        setOpenEditDrawer={setOpenEditDrawer}
        setSelectedPartnership={updateSelectedPartnership}
        onDetailsPage
      />
    </>
  ) : (
    <Box className="partnerships-container">
      <Toolbar className="toolbar">
        <Typography className="title">Partnerships</Typography>
        <NewPartnershipDrawer
          getPartnershipsData={getPartnershipsData}
          partnershipsData={partnershipsData}
          setPartnershipsData={setPartnershipsData}
          openEditDrawer={openEditDrawer}
          selectedPartnership={selectedPartnership}
          setOpenEditDrawer={setOpenEditDrawer}
          setSelectedPartnership={updateSelectedPartnership}
          onDetailsPage={false}
        />
      </Toolbar>
      <Box className="content">
        {partnershipsData?.length > 0 ? (
          <PartnershipsTable
            partnerships={partnershipsData}
            setSelectedPartnership={updateSelectedPartnership}
            setShowDetails={setShowDetails}
            setOpenEditDrawer={setOpenEditDrawer}
          />
        ) : (
          <TableRowsLoader rowsNum={10} />
        )}
      </Box>
    </Box>
  );
};

export default Partnerships;
